module.exports = __webpack_public_path__ + "b045795ffb66e69276773534e7b57fcd.woff";